import { handle } from 'redux-pack';
import { logUncaught } from 'utils/log';

import { mapApiToBillingResponse } from 'models/Bills';

export const handlePaymentsStart = (prevState) => ({
  ...prevState,
  isLoadingPayments: true,
  showPaymentsListError: false,
});

export const handlePaymentsSuccess = (prevState, action) => {
  const billingData = mapApiToBillingResponse(action.payload);

  return {
    ...prevState,
    bills: billingData.bills,
    invoiceIssuanceDetails: billingData.invoiceIssuanceDetails,
    isLoadingPayments: false,
    showPaymentsListError: false,
    hasFetchedPayments: true,
  };
};

export const handlePaymentsFailure = (prevState, action) => {
  logUncaught(new Error('[Failure fetching payments]'), { payload: action.payload });

  return {
    ...prevState,
    isLoadingPayments: false,
    showPaymentsListError: true,
    hasFetchedPayments: true,
  };
};

export const handlePaymentsLifecycle = (action) => ({
  start: (prevState) => handlePaymentsStart(prevState),
  success: (prevState) => handlePaymentsSuccess(prevState, action),
  failure: (prevState) => handlePaymentsFailure(prevState, action),
});

export const addPaymentsToState = (state, action) =>
  handle(state, action, handlePaymentsLifecycle(action));
